<template>
  <div>
    <Navbar></Navbar>
    <Sidebar></Sidebar>
    <div class="main" @click="handleMainClick">
      <router-view></router-view>
      <div class="back-to-top">
        <el-button-group>
          <!-- <el-button type="primary" @click="handleDoc"><el-icon class="el-input__icon"><document /></el-icon>文档帮助</el-button> -->
          <el-button type="warning" @click="handleFeedback"><el-icon class="el-input__icon">
              <help />
            </el-icon>问题反馈</el-button>
        </el-button-group>
      </div>
    </div>
    <feedback-dialog></feedback-dialog>
    <pay-dialog></pay-dialog>
    <favorites-dialog></favorites-dialog>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { onWindowResize, offWindowResize } from '../module/win'
import Navbar from '../components/Navbar.vue'
import Sidebar from '../components/Sidebar.vue'
import PayDialog from '../components/PayDialog.vue'
import FeedbackDialog from '../components/FeedbackDialog.vue'
import FavoritesDialog from '../components/FavoritesDialog.vue'
export default {
  components: { Navbar, Sidebar, PayDialog, FeedbackDialog, FavoritesDialog },
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      windowWidth: 0,
      windowHeight: 0,
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      onWindowResize(callback)
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      offWindowResize()
    })

    // onWindowResize回调方法
    const callback = (windowWidth, windowHeight) => {
      obj.windowWidth = windowWidth
      obj.windowHeight = windowHeight
      store.state.myChart && store.state.myChart.resize() // 图表自适应
      store.state.myChart1 && store.state.myChart1.resize() // 图表自适应
      store.state.myChart2 && store.state.myChart2.resize() // 图表自适应
      store.state.myChart3 && store.state.myChart3.resize() // 图表自适应
      // nextTick(() => {
      //   store.state.myChart && store.state.myChart.resize() // 图表自适应
      // })
      store.commit('setWindowHeight', obj.windowHeight) // 储存窗口高度
      store.commit('setWindowWidth', obj.windowWidth) // 储存窗口宽度
    }

    // mainClickEvent事件
    const handleMainClick = () => {
      vueEvent.emit('mainClickEvent', '')
    }

    // 问题反馈对话框打开事件
    const handleFeedback = () => {
      vueEvent.emit('feedbackDialogVisible', '')
    }

    // 帮助文档页面跳转事件
    const handleDoc = () => {
      let routeData = router.resolve({ path: '/doc' });
      window.open(routeData.href, '_blank');
    }

    return {
      obj,
      store,
      handleMainClick,
      handleFeedback,
      handleDoc,
    }

  }
}
</script>
<style scoped>
.main {
  padding-top: 60px;
  padding-left: 80px;
  padding-right: 60px;
  box-sizing: border-box;
  min-width: 1600px;
}

.back-to-top {
  opacity: 1;
  background: #ffffff;
  color: #fff;
}

.back-to-top:focus {
  background: #ffffff;
  color: #fff;
}

.back-to-top:hover {
  background: #ffffff;
  color: #fff;
}

.back-to-top {
  position: fixed;
  display: block;
  /* padding: 6px 12px 9px 12px; */
  padding: 0 0;
  font-size: 16px;
  /* font-size: 16px; */
  border-radius: 2px;
  right: 0px;
  bottom: 0px;
  transition: background 0.5s;
  z-index: 1000;
}</style>